import { QB_OPERATOR_TYPES } from '../helpers/types.js';

/* eslint-disable complexity */

var conditionSql = function conditionSql(condition, value) {
  var EQUAL = QB_OPERATOR_TYPES.EQUAL,
      NOT_EQUAL = QB_OPERATOR_TYPES.NOT_EQUAL,
      GREATER_THAN = QB_OPERATOR_TYPES.GREATER_THAN,
      LESS_THAN = QB_OPERATOR_TYPES.LESS_THAN,
      CONTAINS = QB_OPERATOR_TYPES.CONTAINS,
      NOT_CONTAINS = QB_OPERATOR_TYPES.NOT_CONTAINS,
      BETWEEN = QB_OPERATOR_TYPES.BETWEEN,
      GREATER_THAN_OR_EQUAL = QB_OPERATOR_TYPES.GREATER_THAN_OR_EQUAL,
      LESS_THAN_OR_EQUAL = QB_OPERATOR_TYPES.LESS_THAN_OR_EQUAL,
      START_WITH = QB_OPERATOR_TYPES.START_WITH;
  if (condition === EQUAL) return "<condition>EQUAL</condition><value>".concat(value, "</value>");
  if (condition === NOT_EQUAL) return "<condition>NOT_EQUAL</condition><value>".concat(value, "</value>");
  if (condition === GREATER_THAN) return "<condition>GREATER_THAN</condition><value>".concat(value, "</value>");
  if (condition === LESS_THAN) return "<condition>LESS_THAN</condition><value>".concat(value, "</value>");
  if (condition === CONTAINS) return "<condition>LIKE</condition><value>".concat(value, "</value>");
  if (condition === NOT_CONTAINS) return "<condition>NOT_LIKE</condition><value>".concat(value, "</value>");
  if (condition === BETWEEN) return "<condition>NOT_LIKE</condition><value><from>".concat(value[0], "</from><to>").concat(value[1], "</to></value>");
  if (condition === GREATER_THAN_OR_EQUAL) return "<condition>GREATER_THAN_OR_EQUAL</condition><value>".concat(value, "</value>");
  if (condition === LESS_THAN_OR_EQUAL) return "<condition>LESS_THAN_OR_EQUAL</condition><value>".concat(value, "</value>");
  if (condition === START_WITH) return "<condition>GREATER_THAN</condition><value>".concat(value, "</value>");
  return condition;
};

var renderFilterSQl = function renderFilterSQl(filter) {
  var _filter$element = filter.element,
      field = _filter$element.field,
      operator = _filter$element.operator,
      value = _filter$element.value;
  return "<filter><field>".concat(field, "</field>").concat(conditionSql(operator, value) || '', "</filter>");
};

var xmlFormat = function xmlFormat(_ref) {
  var main = _ref.main,
      mapGroups = _ref.mapGroups,
      items = _ref.items;

  var groupXML = function groupXML(item, idGroup) {
    if (idGroup === main) {
      var _groupCondition = mapGroups[idGroup].condition === true ? 'AND' : 'OR';

      return "<group value=\"".concat(_groupCondition, "\">").concat(filterXML(item), "</group>"); // eslint-disable-line
    }

    var groupCondition = item.element.condition === true ? 'AND' : 'OR';
    return "<group value=\"".concat(groupCondition, "\">").concat(filterXML(item.children), "</group>"); // eslint-disable-line
  };

  var filterXML = function filterXML(filters) {
    var filterGroup = filters.map(function (filter) {
      if (filter.element.type === 'filter') return "".concat(renderFilterSQl(filter) || '', " ");
      return " ".concat(groupXML(filter), " ");
    });
    return filterGroup.join('');
  };

  var xml = "<xml><query>".concat(groupXML(items, main) || '', "</query></xml>");
  return xml;
};

export { xmlFormat };
//# sourceMappingURL=xmlFormat.js.map
